import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/PickingCancellation';

const PickingCancellationForm = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">PICKING - Cancel Task</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

PickingCancellationForm.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(PickingCancellationForm);
